import React from 'react';
import { Card, CardBody, Alert, Badge } from 'reactstrap';

const TutorDocsPending = () => {
  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-lg-8">
          <Card className="shadow-sm">
            <CardBody className="p-5">
              {/* Success Message */}
              <div style={{
                backgroundColor: '#cfe2ff',
                border: '1px solid #9ec5fe',
                borderRadius: '0.375rem',
                padding: '1.5rem',
                marginBottom: '1.5rem',
                boxShadow: '0 0.5rem 1rem rgba(13, 110, 253, 0.15)'
              }}>
                <h4 style={{ color: '#084298', marginBottom: '1rem', fontWeight: 'bold' }}>
                  <i className="bi bi-hourglass-split" style={{ marginRight: '0.5rem' }}></i>
                  Registration Submitted Successfully!
                </h4>
                <p style={{ color: '#084298', fontSize: '1.1rem', margin: '0' }}>
                  Your tutor profile and documents have been submitted for review.
                </p>
              </div>

              {/* What happens next */}
              <div style={{ color: '#6c757d' }}>
                <p style={{ marginBottom: '0.5rem', fontSize: '1rem' }}>
                  <strong>What happens next?</strong>
                </p>
                <ul style={{ paddingLeft: '1.5rem', marginBottom: '1rem' }}>
                  <li style={{ marginBottom: '0.5rem' }}>
                    Our team will verify your qualifications directly with the institutions
                  </li>
                  <li style={{ marginBottom: '0.5rem' }}>
                    We will review all your uploaded documents including ID and proof of address
                  </li>
                  <li style={{ marginBottom: '0.5rem' }}>
                    This process typically takes 3-5 business days
                  </li>
                  <li>
                    You will be notified via email once your review is complete
                  </li>
                </ul>
                
                <Alert color="info" className="mt-4">
                  <i className="bi bi-info-circle me-2"></i>
                  <strong>Current Status:</strong> <Badge color="warning" className="ms-2">Documents Under Review</Badge>
                </Alert>

                <p style={{ margin: '1rem 0 0.5rem 0', color: '#495057', fontWeight: '500' }}>
                  Thank you for your patience!
                </p>
                
                <p style={{ marginTop: '1.5rem', fontSize: '0.9rem', color: '#6c757d' }}>
                  If you have any questions, please contact your tutoring provider organization.
                </p>
              </div>
            </CardBody>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default TutorDocsPending;
